import { SafeBaseObject } from "@app/core/models/base-object.models"
import { DynamicApiResponse, DynamicApiResponsePaginatedModel } from "@app/core/models/dynamic-api-response.model"
import { DateTime } from "luxon"
import { ResGroups } from "./res-service.models"
import { BookingGuest, BookingJourneySupplement, BookingSupplement, PriceSetupIDEnum, ResBooking } from "./res-booking.model"

export interface ResBkgItemPaxGroupList {
  paxGroupID:number
  itemsIDs:number[]
}
export class ResBkgItem extends SafeBaseObject{
  itemKey=''
  itemsID:number[] = []
  roomConfHdrID:number[] = []

  bkgID = 0

  itineraryDate = DateTime.invalid('empty')
  travelEndDate = DateTime.invalid('empty')

  guestCod = ''
  guestName = ''
  guests:BookingGuest[]=[]
  roomID = 0

  packageID = 0
  productCod = ''
  productName = ''
  itemName = ''

  experienceID = 0
  experienceTemplateHdrID = 0

  suiteCategoryID = 0
  suiteCategory = ''
  priceCategoryID = 0
  priceCategory = ''
  suiteNo = 0

  quantity = 0

  sellingPrice = 0
  sellingPriceTax = 0
  sellingPriceCurrency = ''

  cost = 0
  costTax = 0
  costCurrency = ''
  costBkgCurrency = 0
  costRoe = 0

  bkgCurrency = ''

  paxGroupID = 0
  payerGroupName = ''

  status = ''

  canEdit = false
  villaCost = false
  canDelete = false
  marginType = ''
  marginAmount = 0
  marginPercentage = 0

  prePost = ''

  aggregationGroupRow = 0
  aggregationDescription = ''
  aggregationField = ''
  aggregations:ResGroups[] = []

  isProduct = false
  productID = 0
  editAllocation = false
  editCostAndPrice = false

  isValid = false
  nightNum = 0
  wl = false
  onRequest = false

  bedType = ''
  mcSellingPrice = 0
  mcSellingTax = 0
  mcSellingCurrency = ''
  mcSellingROE = 0

  actualCost = 0
  actualTax = 0
  actualCurrency = ''
  actualExchangeRate = 0

  priceSetupID = 0
  originalPriceSetupID = 0

  commissionable = false
  forcedNetComm = false
  commissionBaseAmount = 0
  commissionPercentage = 0
  vatCommissionPercentage = 0
  commissionNet = 0
  commissionVat = 0
  commissionTotal = 0
  canModifyWholeUnit = false
  isTailorMade = false
  tailorMadeHdr = false
  allPaxGroup:ResBkgItemPaxGroupList[]=[]
  supplements:BookingSupplement[]=[]
  touched = false
  hasRemarkAir = false
  hasRemark = false
  remarkHasChange = false
  remarkAir = ''
  remark = ''
  originalRemark = ''
  hasAttachment = false
  fileGuid = ''
  fileId = 0
  fileName = ''
  hasDetails = false
  supplierID = 0
  serviceID = 0
  optionID = 0
  disableInvoice = false
  amountInvoice = 0
  taxAmountInvoice = 0
  isFinal = false
  realMargin = 0
  purchaseOrderID = 0
  operationalNote = ''
  originalOperationalNote = ''
  currencyCodInvoice = ''
  amountInvoiceBkgCurrency = 0
  isTransport = false

  constructor(data?:any) {
    super();
    if (data) {
      super.updateData(data)
      this.updateData(data)
    }
  }
  static breakRulesBase(item1:BookingSupplement,item2:BookingSupplement|BookingJourneySupplement) {
    return (item1.serviceTypeID === item2.serviceTypeID
              || (item2.optionID === 0
                  && item2.serviceID === 0
                )
            )
            && item1.serviceID  === item2.serviceID
            && item1.optionID   === item2.optionID
            && item1.bedType    === item2.bedType
            && item1.itineraryDate.hasSame(item2.itineraryDate,'day')
  }
  static breakRules(item1:BookingSupplement,item2:BookingSupplement|BookingJourneySupplement,guestCod?:string) {
    return ResBkgItem.breakRulesBase(item1,item2)
            && (item1.paxGroupID === item2.paxGroupID || item1.itemGroupID === item2.itemGroupID)
            && (!guestCod
              || !item1.canModifyWholeUnit
              || item1.guestCod === guestCod
            )
  }
  static createFromSupplement(item:BookingSupplement,booking:ResBooking,fromGuest=false) {
    const bkgItem = new ResBkgItem()
      bkgItem.itemKey = item.itemID.toString()
      bkgItem.itemsID.push(item.itemID)
      bkgItem.itemName = item.optionName
      bkgItem.quantity = item.quantityPP
      bkgItem.bkgID=item.bkgID
      bkgItem.itineraryDate = item.itineraryDate
      bkgItem.travelEndDate = item.tailorMadeItineraryDateTo
      bkgItem.guestCod = item.guestCod
      bkgItem.priceSetupID = item.priceSetupID
      bkgItem.originalPriceSetupID = item.originalPriceSetupID

      bkgItem.sellingPrice = item.sellingPrice
      bkgItem.sellingPriceTax = item.sellingPriceTax
      bkgItem.sellingPriceCurrency = booking?.bkgCurrency ?? item.sellingPriceCurrency ?? ''

      bkgItem.marginType = item.marginType !== '' ? item.marginType : 'NET'
      bkgItem.marginAmount = item.marginAmount
      bkgItem.marginPercentage = item.marginPercentage

      bkgItem.mcSellingCurrency=(item.mcSellingCurrency ?? '') !== '' ? item.mcSellingCurrency: booking?.bkgCurrency ?? bkgItem.sellingPriceCurrency
      bkgItem.mcSellingPrice=item.mcSellingPrice
      bkgItem.mcSellingTax=item.mcSellingTax
      bkgItem.mcSellingROE=item.mcSellingROE

      bkgItem.actualCost = item.actualCost
      bkgItem.actualTax = item.actualTax
      bkgItem.actualCurrency = item.actualCurrency
      bkgItem.actualExchangeRate = item.actualExchangeRate

      bkgItem.cost = item.cost
      bkgItem.costTax =item.costTax
      bkgItem.costCurrency = item.costCurrency
      bkgItem.costRoe = item.exchangeRate

      bkgItem.wl = item.wl
      bkgItem.onRequest = item.onRequest
      bkgItem.isTailorMade = item.isTailorMade
      bkgItem.tailorMadeHdr = item.tailorMadeHdr
      bkgItem.paxGroupID = item.paxGroupID

      bkgItem.canModifyWholeUnit = item.canModifyWholeUnit

      bkgItem.commissionable = item.commissionable
      bkgItem.forcedNetComm = item.forcedNetComm
      bkgItem.commissionBaseAmount = item.commissionBaseAmount
      bkgItem.commissionPercentage = item.commissionPercentage
      bkgItem.vatCommissionPercentage = item.vatCommissionPercentage
      bkgItem.commissionNet = item.commission
      bkgItem.commissionVat = item.commissionVat
      bkgItem.commissionTotal=bkgItem.commissionNet+bkgItem.commissionVat


      bkgItem.bkgCurrency = booking?.bkgCurrency ?? bkgItem.sellingPriceCurrency ?? ''

      bkgItem.canEdit = item.canEdit
      bkgItem.canDelete = item.canDelete

      bkgItem.status = bkgItem.wl ? 'W' : (item.onRequest ? 'A' : 'R')
      //bkgItem.nightNum = item.nightNum

      bkgItem.isValid = true

      bkgItem.bedType = item.bedType

      if(item.serviceID===0 && item.optionID===0) {

      } else {}


      bkgItem.hasRemarkAir = item.remarkAir.length > 0
      bkgItem.remarkAir = item.remarkAir

      bkgItem.hasRemark = item.itemID > 0
      bkgItem.remark = item.message
      bkgItem.originalRemark = bkgItem.remark

      bkgItem.hasAttachment = item.fileGuid.length>0
      bkgItem.fileGuid = item.fileGuid
      bkgItem.fileId = item.fileId
      bkgItem.fileName = item.fileName

      bkgItem.hasDetails = bkgItem.hasRemarkAir || bkgItem.hasRemark || bkgItem.hasAttachment

      if(booking.isValid()) {
        bkgItem.allPaxGroup = []
        booking.supplements.filter(s=>ResBkgItem.breakRulesBase(s,item))
          .forEach(s=>{
            if(bkgItem.allPaxGroup.find(pg=>pg.paxGroupID===s.paxGroupID)) return
            const itemIDs = booking.supplements.filter(item=>ResBkgItem.breakRules(item,s)).map(item=>item.itemID)
            bkgItem.allPaxGroup.push({paxGroupID:s.paxGroupID,itemsIDs:itemIDs})
          })

        bkgItem.allPaxGroup = bkgItem.allPaxGroup.sort((a,b)=>a.paxGroupID-b.paxGroupID)

        const guests = booking.getAllGuests()
        booking.supplements.filter(s=>ResBkgItem.breakRules(s,item,fromGuest ? item.guestCod : undefined))
          .forEach(s=>{
            bkgItem.itemsID.push(s.itemID)
            bkgItem.supplements.push(s)
            const g = guests.find(g=>g.guestCod===s.guestCod)
            if(g) bkgItem.addGuest(g)
          })
      }

      return bkgItem
  }
  static createFromJourneySupplement(item:BookingJourneySupplement,booking:ResBooking) {
    const bkgItem = new ResBkgItem()
    bkgItem.itemKey = item.itemID.toString()
    bkgItem.itemsID.push(item.itemID)
    bkgItem.itemName=item.optionName
    bkgItem.quantity = item.quantity
    bkgItem.bkgID = booking.bkgID
    bkgItem.itineraryDate = item.itineraryDate
    bkgItem.travelEndDate = item.tailorMadeItineraryDateTo
    bkgItem.priceSetupID = item.priceSetupID
    bkgItem.originalPriceSetupID = item.originalPriceSetupID

    bkgItem.sellingPrice = item.sellingPrice
    bkgItem.sellingPriceTax = item.sellingPriceTax
    bkgItem.sellingPriceCurrency = booking.bkgCurrency ?? item.sellingPriceCurrency

    bkgItem.marginType = item.marginType !== '' ? item.marginType : 'NET'
    bkgItem.marginAmount = item.marginAmount
    bkgItem.marginPercentage = item.marginPercentage

    bkgItem.mcSellingCurrency=item.mcSellingCurrency
    bkgItem.mcSellingPrice=item.mcSellingPrice
    bkgItem.mcSellingTax=item.mcSellingTax
    bkgItem.mcSellingROE=item.mcSellingROE

    bkgItem.cost = item.cost
    bkgItem.costTax =item.costTax
    bkgItem.costCurrency = item.costCurrency
    bkgItem.costRoe = item.exchangeRate
    bkgItem.bkgCurrency = booking.bkgCurrency
    bkgItem.wl = item.wl
    bkgItem.onRequest = item.onRequest

    bkgItem.canEdit = item.canEdit
    bkgItem.canDelete = item.canDelete
    bkgItem.isTailorMade = item.isTailorMade
    bkgItem.tailorMadeHdr = item.tailorMadeHdr
    bkgItem.paxGroupID = item.paxGroupID

    bkgItem.canModifyWholeUnit = item.canModifyWholeUnit

    bkgItem.commissionable = item.commissionable
    bkgItem.forcedNetComm = item.forcedNetComm
    bkgItem.commissionBaseAmount = item.commissionBaseAmount
    bkgItem.commissionPercentage = item.commissionPercentage
    bkgItem.vatCommissionPercentage = item.vatCommissionPercentage
    bkgItem.commissionNet = item.commission
    bkgItem.commissionVat = item.commissionVat
    bkgItem.commissionTotal=bkgItem.commissionNet+bkgItem.commissionVat


    bkgItem.status = bkgItem.wl ? 'W' : (item.onRequest ? 'A' : 'R')
    bkgItem.nightNum = item.nightNum

    bkgItem.isValid = true

    bkgItem.bedType = item.bedType
    bkgItem.touched = item.touched

    bkgItem.villaCost = false //!item.canEdit && item.canEditVillaCost
    if(bkgItem.villaCost) {
      bkgItem.isProduct = true
      bkgItem.editAllocation = false
      bkgItem.editCostAndPrice = true
      bkgItem.productID = item.productID
    }

    if(item.serviceID===0 && item.optionID===0) {
    } else {

    }

    if(booking.isValid()) {
      bkgItem.allPaxGroup = []
      booking.supplements.filter(s=>ResBkgItem.breakRulesBase(s,item))
        .forEach(s=>{
          if(bkgItem.allPaxGroup.find(pg=>pg.paxGroupID===s.paxGroupID)) return
          const itemIDs = booking.supplements.filter(item=>ResBkgItem.breakRules(item,s)).map(item=>item.itemID)
          bkgItem.allPaxGroup.push({paxGroupID:s.paxGroupID,itemsIDs:itemIDs})
        })

      bkgItem.allPaxGroup = bkgItem.allPaxGroup.sort((a,b)=>a.paxGroupID-b.paxGroupID)

      const guests = booking.getAllGuests()
      booking.supplements.filter(s=>ResBkgItem.breakRules(s,item))
        .forEach(s=>{
          bkgItem.itemsID.push(s.itemID)
          bkgItem.supplements.push(s)
          const g = guests.find(g=>g.guestCod===s.guestCod)
          if(g) bkgItem.addGuest(g)
        })
      if(item.isTailorMade && bkgItem.supplements.length===0) {
          bkgItem.guests = guests
          bkgItem.guests.forEach(g=>{
            g.isSelected=true
            item.createSupplement(g)
          })
          bkgItem.supplements = item.supplements
        }
    }

    if(item.isTailorMade) {
      if(bkgItem.supplements.length>0 && !item.touched){
        const supplement = bkgItem.supplements[0]
        switch(bkgItem.priceSetupID) {
          case PriceSetupIDEnum.PER_PAX_PRICE_SETUP_ID:
            bkgItem.sellingPrice = supplement.sellingPrice / bkgItem.quantity
            bkgItem.sellingPriceTax = supplement.sellingPriceTax / bkgItem.quantity
            bkgItem.mcSellingPrice = supplement.mcSellingPrice / bkgItem.quantity
            bkgItem.mcSellingTax = supplement.mcSellingTax / bkgItem.quantity
            bkgItem.cost = supplement.cost / bkgItem.quantity
            bkgItem.costTax = supplement.costTax / bkgItem.quantity
            bkgItem.commissionBaseAmount = supplement.commissionBaseAmount / bkgItem.quantity
            bkgItem.commissionNet = supplement.commission / bkgItem.quantity
            bkgItem.commissionVat = supplement.commissionVat / bkgItem.quantity
            break;
          case PriceSetupIDEnum.PER_UNIT_PRICE_SETUP_ID:
            bkgItem.sellingPrice /= bkgItem.quantity
            bkgItem.sellingPriceTax /= bkgItem.quantity
            bkgItem.mcSellingPrice /= bkgItem.quantity
            bkgItem.mcSellingTax /= bkgItem.quantity
            bkgItem.cost /= bkgItem.quantity
            bkgItem.costTax /= bkgItem.quantity
            bkgItem.commissionBaseAmount /= bkgItem.quantity
            bkgItem.commissionNet /= bkgItem.quantity
            bkgItem.commissionVat /= bkgItem.quantity
            break;
        }
        bkgItem.commissionTotal = bkgItem.commissionNet + bkgItem.commissionVat
      }

    }
    return bkgItem
  }
  guestSelectedIfTm(guestCod:string) {
    if(!this.isTailorMade) return false
    const guest = this.supplements.find(s=>s.guestCod===guestCod)
    if(!guest) return false
    return true
  }
  updateItem(item:BookingJourneySupplement | BookingSupplement) {

    item.priceSetupID = this.priceSetupID

    item.sellingPrice = this.sellingPrice
    item.sellingPriceTax = this.sellingPriceTax

    item.marginType = this.marginType
    item.marginAmount = this.marginAmount
    item.marginPercentage = this.marginPercentage

    item.mcSellingCurrency=this.mcSellingCurrency
    item.mcSellingPrice=this.mcSellingPrice
    item.mcSellingTax=this.mcSellingTax
    item.mcSellingROE=this.mcSellingROE

    item.cost = this.cost
    item.costTax = this.costTax
    item.costCurrency = this.costCurrency
    item.exchangeRate = this.costRoe

    item.commissionable = this.commissionable
    item.forcedNetComm = this.forcedNetComm
    item.commissionBaseAmount = this.commissionBaseAmount
    item.commissionPercentage = this.commissionPercentage
    item.vatCommissionPercentage = this.vatCommissionPercentage
    item.commission = this.commissionNet
    item.commissionVat = this.commissionVat

    item.bedType = this.bedType
    item.qty = this.quantity
    item.touched = true
  }
  updateData(data: any) {
    this.itemKey = `${data.ItemID}`

    this.itemsID = `${data.ItemID}`.split(',').map(itemId=>+itemId)

    this.roomConfHdrID = `${data.RoomConfHdrID}`.split(',').map(roomConfHdrID=>+roomConfHdrID)

    this.isProduct = this.productCod === 'CRU'

    this.isValid = this.itemsID.length > 0

    if(this.mcSellingCurrency==='') {
      this.mcSellingCurrency = this.bkgCurrency
      this.mcSellingROE = 1
    }
    if(this.costCurrency==='') {
      this.costCurrency = this.bkgCurrency
      this.costRoe = 1
    }
    if(!this.onRequest && this.status==='On Request') this.onRequest = true
    if(!this.wl && this.status==='Wait List') this.wl = true
  }

  addGuest(guest?:BookingGuest) {
    if(!guest) return
    if(this.guests.find(g=>g.guestCod===guest.guestCod)) return
    this.guests.push(guest)
  }

  static createEmptyPage() {

    const emptyApiResponse = new DynamicApiResponse({
      pageNumber: 1,
      pageTotal: 0,
      recordsCount: 0,
      body: []
    })

    return new DynamicApiResponsePaginatedModel<ResBkgItem>(emptyApiResponse)
  }
}

export class ResBkgItemTotal extends SafeBaseObject{
  sellingPrice = 0
  sellingPriceCurrency = ''
  cost = 0
  costCurrency = ''
  costBkgCurrency = 0
  bkgCurrency = ''
  margin = 0
  realMargin = 0

  amountInvoice = 0

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

  override updateData(data: any) {
    if (!data) return;

    super.updateData(data)
  }
}
export class ResBkgItemFlightInfo extends SafeBaseObject{
  bkgID	= 0
  itemID = 0
  pnr = ''
  airLineID = 0
  airLineCod = ''
  airLine = ''
  airClassID = 0
  airClass = ''
  airClassName = ''
  departureDate = DateTime.invalid('empty')
  departureAirportID = 0
  departureAirportName = ''
  arrivalDate = DateTime.invalid('empty')
  arrivalAirportID = 0
  arrivalAirportName = ''

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

  override updateData(data: any) {
    if (!data) return;

    super.updateData(data)
  }
}
export class ResBkgGroupedItems {
  itemsPaginated = ResBkgItem.createEmptyPage()
  groups:ResGroups[] = []
  total = new ResBkgItemTotal()

  normalizeGuests(booking:ResBooking) {
    const guests = booking.getAllGuests()
    this.itemsPaginated.content.forEach(item=>{
      item.guestCod.split(',').forEach(code=>{
        item.addGuest(guests.find(g=>g.guestCod===code))
      })
      item.guestName =  item.guests.map(g=>g.displayName()).join(', ')
    })
  }
}

export interface IResBkgItemApiParams {
  PageNum?: number
  PageSize?:number
  ProductTypeID?: number
  ProductName?: string
  GuestCod?: number[]
  ItemID?: number
}

export interface IResApiBkgItemsManage {
  ItemID?: number
  ProductCod?: string
  SuiteCategoryID?: number
  PriceCategoryID?: number
  SuiteNo?: number
  Quantity?: number
  SellingPrice?: number
  SellingPriceTax?: number
  Cost?: number
  CostTax?: number
  CostCurrency?: string
  PaxGroupID?: number
  ItemGroupID?: number
  ItineraryDate?: DateTime
  Commissionable?: string
  Status?: string
  BedType?: string

  MCSellingPrice?: number
  MCSellingTax?: number
  MCSellingCurrency?: string
  MCSellingROE?: number
  MarginType?: string
  MarginAmount?: number
  MarginPercentage?: number

  CommissionBaseAmount?: number
  CommissionPercentage?: number
}
